<template>
  <div class='product-ingredient-see--container'>
    <div class='content'>
      <!-- 产品成分图区域 -->
      <div class="ingredient-images-section">
        <div class="section-header">
          <h3>产品成分图</h3>
          <div class="edit-button-section">
            <el-button type="primary" icon="el-icon-edit" @click="handleEdit">
              {{ !Array.isArray(info.ingredient_images) || !info.ingredient_images.length ? '新增' : '修改' }}产品成分
            </el-button>
          </div>
        </div>
        <div v-if="!Array.isArray(info.ingredient_images) || !info.ingredient_images.length">
          <div class="no-images">暂无上传的产品图</div>
        </div>
        <div v-else class="images-container">
          <el-image v-for="(item, i) in info.ingredient_images" :key="i"
                    class="ingredient-image" :src="item" :preview-src-list="[item]">
          </el-image>
        </div>
      </div>

      <!-- 产品成分表格区域 -->
      <div class="ingredient-table-section">
        <h3>产品成分分析</h3>
        <div v-if="markdown" v-html="markdown" class="markdown-content"/>
        <div v-else class="no-images">暂无产品成分分析</div>

      </div>

      <!-- 免责声明区域 -->
      <div class="disclaimer-section">
        <h3>免责声明</h3>
        <div class="disclaimer-content">
          以下分析和列表由 {{ info.ingredient_model_nm }} AI模型
          自动读取并生成，仅供参考，可能存在误差或遗漏。实际成分请以产品官方说明或权威机构检测结果为准。
        </div>
      </div>
    </div>
    <div style='height: 80px;'/>
    <ingredientsEdit @handleSubmit="handleSubmit" ref="edit"></ingredientsEdit>
  </div>
</template>
<script>

import MlInput from '@/components/MlInput/index.vue'
import MlButton from '@/components/MlButton/index.vue'
import {marked} from 'marked'
import IngredientsEdit from "@/pages/lb/product/ingredientsEdit.vue";

export default {
  name: 'IngredientBreakdown',
  components: {IngredientsEdit, MlButton, MlInput},
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    editType: {
      type: String,
      default: 'product'
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    markdown: function () {
      const rawMarkdown = Array.isArray(this.info.ingredient_propose_ai) ? this.info.ingredient_propose_ai.join('\n') : (this.info.ingredient_propose_ai || '')
      return marked.parse(rawMarkdown)
    }
  },
  methods: {
    handleEdit() {
      this.$refs.edit.interfaceEdit({
        ingredient_images: this.info.ingredient_images,
        ingredient_barcode: this.info.ingredient_barcode,
        barcode: this.info.barcode,
      })
    },
    async handleSubmit(data) {
      let id = null
      let dressData = null
      const subData = {...data, id: this.info.id}
      switch (this.editType) {
        case 'product' :
          id = await this.$api.saveProductPart('formIngredient', subData)
          break;
        case 'video' :
          id = await this.$api.saveProductVideoPart('formIngredient', subData)
          break;
        case 'dress':
          dressData = {...this.info, ...subData}
          id = await this.$api.saveProductDressInfo(dressData)
          break;
      }
      if (id) {
        this.$message.success('成分图片上传成功,需耐心等待 AI 解析')
        this.$refs.edit.handleCloseDrawer()
        this.$emit('getInfo')
      }
    }
  }
}
</script>

<style lang='scss'>
.product-ingredient-see--container {
  display: inline;
  .no-images {
    color: #999;
    text-align: center;
    padding: 20px 0;
    font-style: italic;
  }

  .content {
    max-width: 800px;
    margin: 0 auto;
    padding: 16px;

    /* 修改按钮区域样式 */
    .edit-button-section {
      text-align: right;
    }

    /* 产品成分图区域样式 */
    .ingredient-images-section {
      margin-bottom: 24px;

      .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
      }

      h3 {
        margin: 0;
        color: #333;
        font-size: 16px;
        font-weight: 600;
        display: inline-block;
        padding-bottom: 4px;
        border-bottom: 2px solid #ff3176; /* 粉色下划线 */
      }


      .images-container {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
      }

      .ingredient-image {
        width: 60px;
        height: 60px;
        border-radius: 4px;
        border: 1px solid #e8e8e8;
        cursor: pointer;
      }
    }

    /* 产品成分表格区域样式 */
    .ingredient-table-section {
      margin-bottom: 24px;

      h3 {
        margin: 0 0 12px 0;
        color: #333;
        font-size: 16px;
        font-weight: 600;
        display: inline-block;
        padding-bottom: 4px;
        border-bottom: 2px solid #52c41a; /* 绿色下划线 */
      }

      .markdown-content {
        overflow-x: auto;
        max-height: 400px;
        overflow-y: auto;
      }
    }

    /* 免责声明区域样式 */
    .disclaimer-section {
      margin-bottom: 24px;
      padding: 16px;
      background: #e6f7ff; /* 浅蓝色背景 */
      border-radius: 4px;
      border-left: 3px solid #1890ff;

      h3 {
        margin: 0 0 12px 0;
        color: #0050b3;
        font-size: 16px;
        font-weight: 600;
        display: inline-block;
        padding-bottom: 4px;
        border-bottom: 2px solid #0050b3; /* 深蓝色下划线 */
      }

      .disclaimer-content {
        color: #595959;
        line-height: 1.6;
        font-size: 14px;
      }
    }

    /* Markdown 通用样式 */
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 16px 0 8px 0;
      color: #333;
      font-weight: 600;
    }

    h1 {
      font-size: 24px;
    }

    h2 {
      font-size: 20px;
    }

    h3 {
      font-size: 18px;
    }

    h4 {
      font-size: 16px;
    }

    h5 {
      font-size: 14px;
    }

    h6 {
      font-size: 12px;
    }

    p {
      margin: 8px 0;
      line-height: 1.6;
      color: #666;
    }

    ul,
    ol {
      margin: 8px 0;
      padding-left: 24px;
    }

    li {
      margin: 4px 0;
      line-height: 1.6;
    }

    strong {
      font-weight: 600;
      color: #333;
    }

    em {
      font-style: italic;
    }

    code {
      background-color: #f5f5f5;
      padding: 2px 6px;
      border-radius: 3px;
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      font-size: 0.9em;
    }

    pre {
      background-color: #f5f5f5;
      padding: 12px;
      border-radius: 4px;
      overflow-x: auto;
      margin: 12px 0;

      code {
        background: none;
        padding: 0;
      }
    }

    blockquote {
      border-left: 4px solid #ddd;
      padding-left: 16px;
      margin: 12px 0;
      color: #666;
      font-style: italic;
    }

    a {
      color: #1890ff;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    table {
      width: 100%;
      border-collapse: collapse;
      margin: 12px 0;

      th,
      td {
        padding: 8px 12px;
        border: 1px solid #ddd;
      }

      th {
        background-color: #f5f5f5;
        font-weight: 600;
      }
    }
  }
}
</style>
